import { render, staticRenderFns } from "./ChargeRegisterFee.vue?vue&type=template&id=de785b30"
import script from "./ChargeRegisterFee.vue?vue&type=script&lang=js"
export * from "./ChargeRegisterFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports